module.exports = __webpack_public_path__ + "img/ISHANGO.f572bd56.png";